import {
  getMismatch,
  toMismatchMessage,
  toNormalizedTotalAmountInference,
  type InferenceEntry,
} from '@/context/services/report_inferences/utils';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

type UseTotalAmountMismatchMessageParams = {
  totalAmountInference: InferenceEntry | undefined;
  isTotalAmountAlertEnabled: boolean | undefined;
  currentTotalAmount: number;
};

export const useTotalAmountMismatchMessage = ({
  totalAmountInference,
  isTotalAmountAlertEnabled,
  currentTotalAmount,
}: UseTotalAmountMismatchMessageParams): string | undefined => {
  const { t } = useTranslation();
  return useMemo(() => {
    if (!isTotalAmountAlertEnabled) return undefined;
    const mismatch = getMismatch(
      toNormalizedTotalAmountInference(totalAmountInference),
      String(currentTotalAmount)
    );
    return toMismatchMessage(mismatch, t, 'amount');
  }, [t, isTotalAmountAlertEnabled, totalAmountInference, currentTotalAmount]);
};
